import {Box, IconButton, Typography} from "@mui/material";
import {Cancel, CheckCircle} from "@mui/icons-material";
import {LocalizedLanguages} from "./Localization";
import {makeStyles} from "@mui/styles";
import {LocalisedString} from "./LocalizedText";

const useStyles = makeStyles((theme) => ({
    date: {
        margin: theme.spacing(1),
        width: 90
    },
    id: {
        margin: theme.spacing(1),
        cursor: "pointer",
        width: 90
    },
    language: {
        width: 30
    },
    row: {
        display: "flex",
        flexGrow: 1,
        marginRight: theme.spacing(10)
    },
    text: {
        flexGrow: 1,
        margin: theme.spacing(1),
        width: 250
    },
    wrapped: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    }
}));

interface ILocalizedRow {
    localizedKey: string
    localization: LocalisedString
    onClick: (key: string, language: string) => void
    style: any
}
export function TextRow({localizedKey, localization, onClick, style}: ILocalizedRow) {
    const classes = useStyles();
    const date = new Date(localization.english.timestamp);

    return (
        <Box display="flex" key={localizedKey} style={style}>
            <Box className={classes.row}>
                <Box className={classes.id} onClick={() => navigator.clipboard.writeText(localizedKey)}>
                    <Typography className={classes.wrapped} title={localizedKey}>
                        {localizedKey}
                    </Typography>
                </Box>
                <Box className={classes.text}>
                    <Typography className={classes.wrapped} title={localization.english.text}>
                        {localization.english.text}
                    </Typography>
                </Box>
                <Box className={classes.date} title={date.toLocaleString()}>
                    <Typography className={classes.wrapped}>
                        {date.toLocaleDateString()}
                    </Typography>
                </Box>
                {Object.keys(LocalizedLanguages).map(language => {
                    return (
                        <Box className={classes.language} key={language}>
                            <IconButton color={
                                localization[language]?.timestamp > localization.english.timestamp ?
                                    "primary" : "warning"} data-key={localizedKey} data-language={language}
                                        onClick={() => onClick(localizedKey, language)} size="small"
                                        title={localization[language] ?
                                            new Date(localization[language].timestamp).toLocaleString() : ""}>
                                {localization[language] ? <CheckCircle/> : <Cancel/>}
                            </IconButton>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}
